import Recategorizacion from "./Recategorizacion";
export default Recategorizacion;